import { render, staticRenderFns } from "./Bednight.vue?vue&type=template&id=2fe384d1&"
import script from "./Bednight.vue?vue&type=script&lang=js&"
export * from "./Bednight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports